import { AutoEletric } from '../../shared/model/auto-eletric';
import { AttendingConversion } from './attending-conversion';
import { TechnicianLocationStatus } from './technician-location-status';

export default class AttendingInfo {
  constructor(public id?: number,
              public startedDate?,
              public installationCompletedDate?,
              public interruptionDate?,
              public requestValidationDate?,
              public initialLocation?,
              public interruptionLocation?,
              public installationCompletedLocation?,
              public requestValidationLocation?,
              public files?,
              public attendingInfoHistories?,
              public attendingInterruptionReason?,
              public attendingStatus?,
              public requestValidation?,
              public autoEletric?: AutoEletric,
              public autoEletricStep?,
              public technicianArrivalStatus?: TechnicianLocationStatus,
              public conversion?: AttendingConversion,
              public rescheduled?) { }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/attending/model/attending-info.ts